<script lang="ts">
    import type {Writable} from 'svelte/store';
    import type {HeadlessTabsApiData, TabId} from 'shared/ui-widgets/tabset/types';
    import {getContext, onDestroy, tick} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {TABS_CONTEXT_NAME} from 'shared/ui-widgets/tabset/types';

    export let tabToSelect: TabId | null = null;

    let lastTabSelected: TabId | null = null;
    let lastTabCount = 0;

    const tabsApi: Writable<any> = getContext(TABS_CONTEXT_NAME);
    if (!tabsApi) {
        throw new Error(
            '<KpTabButtonsActiveTabSelector /> is missing a parent <TabGroup /> component.'
        );
    }

    let apiData: HeadlessTabsApiData;
    const apiDataUnsubscribe = tabsApi.subscribe((currentApiData: HeadlessTabsApiData) => apiData = currentApiData);
    $: if (lastTabSelected !== tabToSelect || apiData.tabs.length > lastTabCount) findAndSelectTab(apiData, tabToSelect);

    function findAndSelectTab(api: HeadlessTabsApiData, tab: TabId): boolean {
        const tabElement = api.tabs.find((element) => element.dataset.tab === tab);

        if (!exists(tabElement)) {
            return false;
        }

        const tabIndex = api.tabs.indexOf(tabElement);
        lastTabSelected = tab;
        lastTabCount = api.tabs.length;

        tick().then(() => {
            api.setSelectedIndex(tabIndex);
        });

        return true;
    }

    onDestroy(() => {
        apiDataUnsubscribe();
    });
</script>
